import {
  Chip,
  Container,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
  styled,
} from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import SingleAccordion from 'components/SingleAccordion';

const primary = theme.palette.primary.main;

export const StyledContainer = styled(Container)`
  padding-top: 2rem;

  ${theme.breakpoints.up('md')} {
    max-width: 880px;
  }
`;

export const StyledPaper = styled(Paper)`
  border-radius: ${theme.radius?.lg};

  ${theme.breakpoints.down('md')} {
    box-shadow: none;
  }

  ${theme.breakpoints.up('sm')} {
    padding-top: 60px;
  }

  ${theme.breakpoints.up('md')} {
    padding-top: 40px;
  }
`;

export const StyledStack = styled(Stack)`
  padding: 1.25rem 0;
`;

export const Label = styled(Typography)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledChip = styled(Chip)`
  text-transform: capitalize;

  .MuiSvgIcon-root {
    width: 1.5em;
  }

  .MuiChip-label {
    padding-left: 0;
  }
`;

export const StyledListItem = styled(ListItem)`
  padding: 0;
`;

export const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 32px;

  svg {
    fill: ${primary};
  }
`;

export const StyledListItemText = styled(ListItemText)`
  .MuiTypography-root {
    color: ${primary};
  }
`;

export const ExptyViewWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const EmptyViewTitle = styled(Typography)`
  margin: 1rem 0;
`;

export const StyledSingleAccordion = styled(SingleAccordion)`
  margin-top: 2rem;
`;
